import React, { useEffect } from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import BlockIcon from "@mui/icons-material/Block";
import { useNavigate } from "react-router-dom";

const UserErrorPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Clear authentication data
    localStorage.removeItem("accessToken");
  }, []);

  const handleBackToLogin = () => {
    navigate("/login");
    window.location.reload();
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f5f5f5",
        padding: { xs: 2, sm: 3, md: 4 },
      }}
    >
      <Paper
        elevation={24}
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", sm: 500 },
          borderRadius: { xs: 2, sm: 3, md: 4 },
          overflow: "hidden",
          backgroundColor: "#ffffff",
        }}
      >
        <Box
          sx={{
            padding: { xs: 3, sm: 4, md: 5 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
          }}
        >
          {/* Error Icon */}
          <Box
            sx={{
              mb: 3,
              width: 100,
              height: 100,
              borderRadius: "50%",
              backgroundColor: "#ffebee",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <BlockIcon
              sx={{
                fontSize: 60,
                color: "#f44336",
              }}
            />
          </Box>

          {/* Error Title */}
          <Typography
            variant="h4"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: "#f44336",
              fontSize: { xs: "1.5rem", sm: "2rem" },
            }}
          >
            Access Blocked
          </Typography>

          {/* Error Message */}
          <Typography
            variant="h6"
            sx={{
              mb: 3,
              fontWeight: 500,
              color: "#666",
              fontSize: { xs: "1rem", sm: "1.25rem" },
            }}
          >
            Your account has been blocked
          </Typography>

          {/* Error Description */}
          <Box
            sx={{
              mb: 4,
              p: 3,
              backgroundColor: "#fff3e0",
              borderRadius: 2,
              border: "1px solid #ffe0b2",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#e65100",
                fontWeight: 500,
                mb: 1,
              }}
            >
              Why is my account blocked?
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              Your account has been temporarily blocked by the administrator.
              This may be due to security concerns or policy violations.
            </Typography>
          </Box>

          {/* Contact Information */}
          <Box
            sx={{
              mb: 4,
              p: 3,
              backgroundColor: "#f5f5f5",
              borderRadius: 2,
              width: "100%",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                color: "#333",
                fontWeight: 500,
                mb: 1,
              }}
            >
              Need Help?
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#666",
                lineHeight: 1.6,
              }}
            >
              Please contact your system administrator for more information or
              to request account reactivation.
            </Typography>
          </Box>

          {/* Back to Login Button */}
          <Button
            fullWidth
            variant="contained"
            size="large"
            onClick={handleBackToLogin}
            sx={{
              borderRadius: "30px",
              padding: "12px 24px",
              fontSize: "1rem",
              fontWeight: 600,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
              background: "linear-gradient(135deg, #42A5F5 0%, #1565C0 100%)",
              boxShadow: "0 4px 15px rgba(66, 165, 245, 0.4)",
              transition: "all 0.3s ease",
              "&:hover": {
                background: "linear-gradient(135deg, #1565C0 0%, #0D47A1 100%)",
                boxShadow: "0 6px 20px rgba(66, 165, 245, 0.6)",
                transform: "translateY(-2px)",
              },
              "&:active": {
                transform: "translateY(0)",
              },
            }}
          >
            Back to Login
          </Button>
        </Box>

        {/* Footer */}
        <Box
          sx={{
            padding: 2,
            textAlign: "center",
            borderTop: "1px solid #f0f0f0",
            backgroundColor: "#fafafa",
          }}
        >
          <Typography
            variant="caption"
            sx={{
              color: "#999",
              fontSize: { xs: "0.7rem", sm: "0.75rem" },
            }}
          >
            © Copyright {new Date().getFullYear()} Bundle Kit. All rights
            reserved.
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default UserErrorPage;
